module.exports = __webpack_public_path__ + "img/person_2.fd5c929.webp";